import {bootstrapApplication} from '@angular/platform-browser';
import {appConfig} from './app/app.config';
import {AppComponent} from './app/app.component';
import {isNative} from "./app/utils";
import {CapacitorUpdater} from "@capgo/capacitor-updater";


CapacitorUpdater.notifyAppReady();

performance.mark('start-app');

// setInterval(() => console.log('tick'), 1000);
//
// if ('serviceWorker' in navigator) {
//   navigator.serviceWorker.getRegistrations()
//     .then(regs => regs.forEach(r => r.unregister()))
//     .then(() => {
//       console.log('All service workers unregistered successfully.');
//       // Optionally reload so the page loads without a SW
//       // window.location.reload();
//     });
// }


  console.log("Application starting up")
if (!isNative) {
    // GenericOAuth2.redirectFlowCodeListener({
    //   ...cognitoOptions,
    //   response_url: cognitoOptions.web!.redirectUrl!,
    // })
    //   .then(
    //     () => console.log('Redirect flow code listener response.'),
    //   )
    //   .catch(
    //   (error) => console.warn('Error in redirectFlowCodeListener:', error)
    // );
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err))
  .finally(() => {
    performance.mark('end-app');
    performance.measure('app-initialization', 'start-app', 'end-app');

    const measures = performance.getEntriesByName('app-initialization');
    console.log(`App Initialization Time: ${measures[0]?.duration}ms`);
  });
